import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType, concatLatestFrom } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { MessagesActions } from '../messages/messages.actions';
import { PendingActionActions } from './pending-action.actions';
import { selectPendingActionState } from './pending-action.reducer';
import { Store } from '@ngrx/store';
import { ChatAdminActions } from '../chat-admin/chat-admin.actions';
import { PendingActionType } from '../../types/enum';

@Injectable({
  providedIn: 'root',
})
export class PendingActionEffects {
  constructor(private readonly actions$: Actions, private store: Store) {}

  callDialogApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PendingActionActions.handlePendingActionAfterRefresh),
      concatLatestFrom(() => [this.store.select(selectPendingActionState)]),
      filter(
        ([, pendingActionState]) =>
          pendingActionState.type == PendingActionType.callDialogApi
      ),
      map(([, pendingActionState]) =>
        MessagesActions.callDialogApi({ query: pendingActionState.parameters })
      )
    )
  );

  escalateFromChatAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PendingActionActions.handlePendingActionAfterRefresh),
      concatLatestFrom(() => [this.store.select(selectPendingActionState)]),
      filter(
        ([, pendingActionState]) =>
          pendingActionState.type == PendingActionType.escalateToLiveChat
      ),
      map(() => ChatAdminActions.escalate())
    )
  );
}
